export default __webpack_public_path__ + "static/media/Sunspark.213d6fa3.jpg";